import React from 'react'
import PropTypes from 'prop-types'
import { useRSSFeedContext } from './RSSFeedContext'

function RSSFeedItems ({
  className = 'flex flex-col',
  style,
  children, ...rest
}) {
  const { items } = useRSSFeedContext()

  return (
    <div className={className} style={style} {...rest}>
      {items.map((item, index) =>
        React.Children.map(children, (child) =>
          React.isValidElement(child)
            ? React.cloneElement(child, {
              item,
              key: `${item.id || index}`
            })
            : child
        )
      )}
    </div>
  )
}

RSSFeedItems.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
}

export default RSSFeedItems
